import React from "react";
import NotificationList from "@/components/notifications/NotificationList";
import { Bell } from "lucide-react";

const C = { navy: "#1C4358", slate: "#4B5563", charcoal: "#252221" };

export default function NotificationCenter() {
  return (
    <div className="max-w-4xl mx-auto pb-16" data-testid="notification-center-page">
      <h1 className="font-display text-2xl font-bold flex items-center gap-2 mb-1" style={{ color: C.charcoal }}>
        <Bell size={22} style={{ color: C.navy }} /> Notifications
      </h1>
      <p className="text-[13px] mb-5" style={{ color: C.slate }}>
        Your routed alerts — new leads, chat escalations, tasks &amp; follow-ups due, and documents needing review.
      </p>
      <NotificationList variant="staff" />
    </div>
  );
}
